export default {
  placeholder: 'Search videos, guides, and articles',
  videos: 'Videos',
  videos_placeholder: 'Search for videos',
  no_results_found: 'No matching results found! Try with different search term',
  empty: 'Start typing!!!',
  courses_placeholder: 'Search courses',
  learners_placeholder: 'Search Learners'
};
